import React from 'react';

/**
 * Shown wherever a browse screen has nothing to show because the selected
 * catalog provider has no credential. Search and streaming still work without
 * one, so this says what is missing rather than presenting itself as an outage.
 */
const CatalogNotice = () => (
  <div className="notice">
    <b>The catalog isn't connected</b>
    <p>
      <code>CATALOG_PROVIDER</code> is set to <code>tmdb</code>, which needs a key. Either add{' '}
      <code>TMDB_API_KEY</code> to <code>.env</code>, or switch to{' '}
      <code>CATALOG_PROVIDER=cinemeta</code>, which needs no key at all. Restart the server after
      either change. Searching for a release and streaming it works without a catalog.
    </p>
  </div>
);

export default CatalogNotice;
